import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import localizedSchema, { ILocalizedText } from './localized-text';

export interface IAmenity {
  _id: ObjectID;
  type: string;
  icon?: string;
  names: ILocalizedText;
}

export interface IAmenityDocument extends mongoose.Document, IAmenity {
  _id: ObjectID;
}

const schema = new Schema(
  {
    type: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    names: {
      type: localizedSchema,
      required: true,
      validate: {
        validator(localizedMap: ILocalizedText) {
          const englishTag = localizedMap.en;
          if (englishTag !== englishTag.toLowerCase()) {
            throw new Error('amenities are supposed to be lowercase');
          }
          return true;
        },
        // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35860
        message: (props: any) => props.reason.message,
      },
    },
  },
  { timestamps: true },
);

schema.index({ 'names.en': 1, type: 1 }, { unique: true });

export default schema;
